import type { FC } from 'react';

import { Placeholder, useRendering } from '@eneco/cms';
import { Stack } from '@eneco/sparky';

import { BUTTON_LINE_UP_SLOTS, resolveSlot } from './slots';

/**
 * `ButtonLineUp` block for the CMS-agnostic lane, serving **both** providers.
 *
 * Carries no content of its own — a wrapping row of the `ButtonLink` blocks in its placeholder,
 * mirroring `libs/sitecore/components/content/src/ButtonLineUp/ButtonLineUp.tsx` 1:1, including the
 * `Stack` rendering when the slot is empty.
 */
const ButtonLineUp: FC = () => {
  const buttonsSlot = resolveSlot(useRendering(), BUTTON_LINE_UP_SLOTS.buttons);

  return (
    <Stack direction={{ initial: 'column', md: 'row' }} gap="5" wrap>
      {buttonsSlot ? <Placeholder name={buttonsSlot} /> : null}
    </Stack>
  );
};

export default ButtonLineUp;
